import React, { FC, ReactElement } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { TooltipProps } from '@mui/material';

interface TooltipIfProps extends TooltipProps {
    children: JSX.Element;
}

const TooltipIf: FC<TooltipIfProps> = (props): ReactElement => {
    const { children, ...rest } = props;

    if (rest.title) {
        return (
            <Tooltip {...rest}>
                <span>{children}</span>
            </Tooltip>
        );
    }

    return children;
};

export default TooltipIf;
